export class CommonRegularExpressions {
    public static PhoneNumberRegex = /^07\d{8}\d?$/
}
